if (!customElements.get('product-card-item')) {
  customElements.define('product-card-item', class ProductCardItem extends HTMLElement {
    constructor() {
      super();
    }

    async checkWishlist(componentProductOptionsPopup, enableAll) {
      const componentProductOptions = componentProductOptionsPopup.querySelectorAll('.component-product-options__option');

      if (enableAll) {
       for(let componentProductOption of componentProductOptions) {
        componentProductOption.classList.remove('disable')
       }
       return;
      }

      let listContents = await app.swymApi.getListContents();
      const wishlistListVariantIdList = listContents.map((wishlist) => wishlist.epi);
      for(let componentProductOption of componentProductOptions) {
        for(let wishlistListVariantId of wishlistListVariantIdList) {
          if (+componentProductOption.dataset.variantId === wishlistListVariantId) { 
            componentProductOption.classList.add('disable');
          }
        }
      }
    }

    openVariantsPopup(idSelector, opener) {
      // show popup
      const componentProductOptionsPopup = document.getElementById(idSelector);
      componentProductOptionsPopup.classList.add('component-product-options-popup-visible');
      componentProductOptionsPopup.onblur = null;
      setTimeout(() => {
        componentProductOptionsPopup.focus();
        componentProductOptionsPopup.onblur = (event) => {
          componentProductOptionsPopup.classList.remove('component-product-options-popup-visible');
        };
      }, 200); // #note 200 component-product-options-popup-visible transition duration

      if(opener.classList.contains('component-product-card-wishlist')) {
        componentProductOptionsPopup.setAttribute('data-wishlist-popup', true);   
        this.checkWishlist(componentProductOptionsPopup);         
      } else {
        componentProductOptionsPopup.removeAttribute('data-wishlist-popup');
        this.checkWishlist(componentProductOptionsPopup, true); 
      }
    }

    connectedCallback() {
      this.getElements();
      this.addEventListeners();
    }

    _isMobile() {
      return window.innerWidth < 750;
    }

    getElements() {
      this.windowClickHandler = null;
      this.imageContainer = this.querySelector(this.dataset.imageContainerSelector);
      this.productRegularPrice = this.querySelector(this.dataset.productRegularPrice);
      this.componentProductOptionsModal = this.querySelector('.component-product-options-modal');
    }

    addEventListeners() {
      this.addEventListener('click', (event) => {
        if(event.target.closest('.product-color')) {
          const modal = document.querySelector(this.dataset.colorModalSelector);
          modal && modal.toggleModal(event);
        }
      });
    }
  });
}

if (!customElements.get('product-card-item-modal')) { 
  customElements.define('product-card-item-modal', class productCardItemModal extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setAttribute(this.dataset.closedAttribute, '');
      this.addEventListeners();

      if(!this.hasAttribute('closed')) {
        this.setAttribute('closed', '');
      }

      if(!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', 0);
      }

      if(!this.hasAttribute('initial')) {
        this.setAttribute('initial', '');
      }
    }
    
    renderTemplate() {
      if(this.hasAttribute('initial')) {
        const template = this.querySelector('template');
        const templateContentClone = template && template.content.cloneNode(true);
        templateContentClone && this.appendChild(templateContentClone);
        this.removeAttribute('initial');
      }
    }

    toggleModal(event) {
      if(event.type === 'click' && this.hasAttribute('closed')) {
        this.renderTemplate();
        this.setAttribute('open', '');
      } else if(event.type == 'blur') {
        this.removeAttribute('open');
      }
    }

    _onTransitionend(event) {
      if(this.hasAttribute('open')) {
        this.focus();
        this.onblur = this.toggleModal.bind(this);
        this.removeAttribute('closed');
      } else {
        this.setAttribute('closed', '');
      }
    }

    addEventListeners() {
      this.addEventListener("transitionend", this._onTransitionend.bind(this));
    }
  });
}
